/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query PhoneNumberoReplacementReadUniqueQuery($phoneNumberoReplacementId: ID!) {
  PhoneNumberoReplacementReadUnique(phoneNumberoReplacementId: $phoneNumberoReplacementId) {
    message,
    status,
    percentageRate,
    CustomerAccount {
      id,
      displayName
    },
    Mcc {
      id,
      mcc,
      countryName
    },
    Mnc {
      id,
      mnc,
      network
    },
     PhoneNumbero {
      id
      phoneNumbero
    }
    PhoneNumberoDirectory {
      displayName
      id
    }
  }
}
`
